import { SITE } from '../config/site';
import { absoluteUrl } from '../config/seo';
import { mediaUrl } from '../utils/mediaUrl';

function productImageUrls(product) {
  const fromGallery = (product.images || [])
    .map((img) => mediaUrl(img.url || img))
    .filter(Boolean);

  if (fromGallery.length > 0) return fromGallery;

  const fallback = mediaUrl(product.image_url);
  return fallback ? [fallback] : [absoluteUrl(SITE.defaultOgImage)];
}

export function buildProductJsonLd(product) {
  if (!product?.name) return null;

  const amount = product.price?.amount;
  const currency = product.price?.currency || 'RUB';
  const quantity = parseFloat(product.quantity);
  const inStock = Number.isFinite(quantity) ? quantity > 0 : true;
  const description =
    product.description ||
    product.full_name ||
    `${product.name} — купить в магазине nextcake в Волгограде`;

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: String(description).replace(/\s+/g, ' ').trim(),
    sku: product.article || product.id,
    image: productImageUrls(product),
    brand: {
      '@type': 'Brand',
      name: SITE.brandName,
    },
    category: product.categories?.[0]?.name,
    offers: {
      '@type': 'Offer',
      url: absoluteUrl(`/product/${product.id}`),
      priceCurrency: currency,
      ...(amount != null ? { price: String(parseFloat(amount)) } : {}),
      availability: inStock
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
      seller: {
        '@type': 'Organization',
        name: SITE.brandName,
        url: SITE.url,
      },
      areaServed: SITE.city,
    },
  };
}
